/** Structured codes for seller price band enforcement (API + UI). */
export const SELLER_PRICE_BAND_ERROR_CODES = {
  PRICE_OUT_OF_BAND: "PRICE_OUT_OF_BAND",
  INSUFFICIENT_MARKET_DATA: "INSUFFICIENT_MARKET_DATA",
  BAND_UNAVAILABLE: "BAND_UNAVAILABLE",
} as const;

export type SellerPriceBandErrorCode =
  (typeof SELLER_PRICE_BAND_ERROR_CODES)[keyof typeof SELLER_PRICE_BAND_ERROR_CODES];
